import { ProgramInvitationsV1NaptimeResource } from './__generated__/ProgramInvitationsV1';

class ProgramInvitations extends ProgramInvitationsV1NaptimeResource {
  static RESOURCE_NAME = 'programInvitations.v1' as const;
}

export default ProgramInvitations;
